module.exports = __webpack_public_path__ + "fonts/Inter-Medium.18b8c68.ttf";